// src/utils/formatNumber.js
const formatNumber = (num) => {
  const n = Number(num);
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace('.0', '') + 'M';
  if (n >= 1_000)      return (n / 1_000).toFixed(1).replace('.0', '') + 'K';
  return String(n);
};

export default formatNumber;